export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ""

  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i])
  }

  return window.btoa(binary)
}

export function base64ToArrayBuffer(base64: string) {
  try {
    const binary = Uint8Array.from(window.atob(base64), (char) => char.charCodeAt(0))

    return binary.buffer
  } catch (error) {
    throw new Error(`Failed to convert to buffer: ${error.message}`)
  }
}
